import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../services/utils/storage.service';
import { GroupModel } from 'src/app/modules/group/shared/models/group.model';
import { StorageConstant } from '../../constants/storage.constant';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent {
  constructor(private router: Router, private storageService: StorageService) {}

  async goToAllEvents(): Promise<void> {
    const group = await this.storageService.get<GroupModel>(StorageConstant.GROUP);
    this.router.navigateByUrl(
      `event/${group?.grLocation?.locCity?.replaceAll(' ', '-')?.toLowerCase()}-badminton/event}`
    );
  }
}
